import * as classNames from 'classnames'
import * as React from 'react'
import Cancel from '../icons/ui/Cancel'
import Polygon from '../icons/ui/Polygon'

interface IListFilterDropdownProps {
  label: string
}

interface IListFilterDropdownState {
  filterOpen: boolean
}

class ListFilterDropdown extends React.Component<IListFilterDropdownProps, any, any> {
  constructor(props: IListFilterDropdownProps) {
    super(props)

    this.state = {
      filterOpen: false
    }
  }

  public render() {
    return (
      <div
        className={classNames({
          'inline-block relative': true,
          'font-grey2': !this.state.filterOpen,
          'bg-blue-grey border-blue-grey border-radius font-white': this.state.filterOpen
        })}
      >
        {this.label()}
        {this.dropDown()}
      </div>
    )
  }

  private dropDown = () => (
    <div
      className={classNames({
        'z2 bg-white shadow absolute p2': true,
        'display-none': !this.state.filterOpen
      })}
    >
      {this.props.children}
    </div>
  )

  private label = () => (
    <p className='flex items-center m0 p1'>
      <span
        className={classNames({
          'mr1 h5': true,
          'font-grey2': !this.state.filterOpen,
          'font-white': this.state.filterOpen
        })}
      >
        {this.props.label}
      </span>
      <Polygon
        className={classNames({
          'svg-grey': !this.state.filterOpen,
          'svg-white mr1': this.state.filterOpen
        })}
        onClick={this.openFilter}
        height={10}
        width={10}
      />
      {this.state.filterOpen && <Cancel height={10} width={10} onClick={this.closeFilter} />}
    </p>
  )

  private openFilter = () => {
    this.setState({ filterOpen: true })
  }

  private closeFilter = () => {
    this.setState({ filterOpen: false })
  }
}

export default ListFilterDropdown



// WEBPACK FOOTER //
// ./src/components/ui/ListFilterDropdown.tsx